import request from '../common'

export function createPayLog (data) {
    return request({
      url: '/pay/createPayLog/' + data.id,
      method: 'post'
    })
  }

export function payForm (params) {
  return request({
    url: '/pay/repair/pay-form',
    method: 'post',
    params: params
  })
}


export function wxPay (params) {
  return request({
    url: '/pay/repair/wxPay/Mweb',
    method: 'post',
    params: params
  })
}

export function queryAlipayOrder (params) {
  return request({
    url: '/pay/aliPay/queryOrder',
    method: 'get',
    params: params
  })
}

export function queryPayLog (params) {
  return request({
    url: '/pay/queryPayLog',
    method: 'get',
    params: params
  })
}

export function queryOrder (params) {
  return request({
    url: '/pay/wxPay/queryOrder',
    method: 'get',
    params: params
  })
}

export function payWxBrower (params) {
  return request({
    url: '/pay/repair/pay-wx',
    method: 'post',
    params: params
  })
}

export function alipayForm (params) {
  return request({
    url: '/pay/repair/pay-form-H5',
    method: 'post',
    params: params
  })
}

export function applePayVerify (data) {
  return request({
    url: '/pay/applePay/verifyV2?noLoading',
    method: 'post',
    data
  })
}

export function discount (params) {
  return request({
    url: '/discount/get?noLoading',
    method: 'get',
    params
  })
}

export function getDiscountList (params) {
  return request({
    url: '/discount?noLoading',
    method: 'get',
    params
  })
}

export function createDisCountOrder (params) {
  return request({
    url: '/pay/discount/' + params.id + '?noLoading',
    method: 'post',
  })
}





// WEBPACK FOOTER //
// ./src/api/buy.js